import React, { FC } from "react";

import { useInsuranceLabels } from "../../../../Utils/Context/labelsContext";

import { Button } from "../../../../Partials/Button";
import { StreamLineIcon } from "../../../../../SvgIcon/StreamLineIcon";

interface BookingCalendarControlsProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const BookingCalendarControls: FC<BookingCalendarControlsProps> = (
  props
) => {
  const { onCancel, onAccept } = props;

  const { buttons } = useInsuranceLabels();

  return (
    <div className="bookingCalendarControls">
      <Button
        className="bookingCalendarControl__cancel"
        onClick={onCancel}
        type="clear"
        size="medium"
        tier="secondary"
      >
        <span>{buttons.cancelButtonLabel}</span>
      </Button>
      <Button
        className="bookingCalendarControl__accept"
        onClick={onAccept}
        type="solid"
        size="medium"
        tier="secondary"
      >
        <span className="insuranceButton__label">
          <span>{buttons.applyButtonLabel}</span>
          <StreamLineIcon iconName="s-arrow-right-dash" />
        </span>
      </Button>
    </div>
  );
};
